import type { BuildingEntity } from "../../core/entity/EntityType/Building"
import { Property_Building2_Building2_GLTF_Model } from "../gltf_models.generated"
import makePropertyObject3DFactory from "./makePropertyObject3DFactory"

// export default makePropertyObject3DFactory<BuildingEntity>(Property_Building1_Building1_GLTF_Model)
export default makePropertyObject3DFactory<BuildingEntity>(Property_Building2_Building2_GLTF_Model)
